<template>
  <div>
    <div class="box-card">
      <div v-loading="loading">
        <network-info :network-info="networkInfo" v-if="STA"></network-info>
        <div class="setting" v-if="STA">{{$t('lang.wire.functionConfiguration')}}</div>
        <el-divider content-position="left">
          <span style="line-height: 1;color: #020a13;font-size: 16px;padding-bottom: 10px;margin-top:20px">
            {{$t('lang.ConfigSetting.deiveceSetting')}}
          </span>
        </el-divider>
        <div class="device-setting">
          <el-form :model="deviceSettingForm" label-width="100px" label-position="right" inline>
            <el-form-item :label="`${$t('lang.ConfigSetting.channel')}：`" prop="channel">
              <el-select size="mini" v-model="deviceSettingForm.channel">
                <el-option
                  v-for="item in channelOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="`${$t('lang.ConfigSetting.bandwidth')}：`" prop="htmode">
              <el-select size="mini" v-model="deviceSettingForm.htmode">
                <el-option
                  v-for="item in htmodeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <el-divider content-position="left">
          <span style="line-height: 1;color: #020a13;font-size: 16px;padding-bottom: 10px;margin-top:20px">
            {{$t('lang.ConfigSetting.interfaceSetting')}}
          </span>
        </el-divider>
        <el-table :data="wifiData" border strip style="margin-top: 50px">
          <el-table-column :label="$t('lang.ConfigSetting.BasicSettings')" width="130px">
            <template slot-scope="scope">
              <!-- <div v-if="scope.row.options.disabled=='1'">
                <span>{{$t('lang.ConfigSetting.disEnable')}}</span> 
                <el-button type="primary" size="mini" style="margin-left: 10px" @click="OnOff(scope.row)">
                {{$t('lang.ConfigSetting.DEABLE')}} 
              </el-button>
              </div>
              <div v-else>
                <span>{{$t('lang.ConfigSetting.isEnable')}}</span> 
                <el-button type="danger" size="mini" style="margin-left: 10px" @click="OnOff(scope.row)">
                {{$t('lang.ConfigSetting.DISABLE')}}
              </el-button>
              </div> -->
              <el-checkbox v-model="scope.row.options.disabled"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column :label="$t('lang.ConfigSetting.Mode')">
            <template slot-scope="scope">
              <el-select v-model="scope.row.options.mode" :placeholder="$t('lang.ConfigSetting.pleaseChoose')" size="mini" >
                <el-option
                  v-for="item in ModeList"
                  v-if="item.value==scope.row.options.mode"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="ESSID">
            <template slot-scope="scope">
              <el-input size="mini" v-model="scope.row.options.ssid"></el-input>
            </template>
          </el-table-column>
          <el-table-column :label="$t('lang.ConfigSetting.HideESSID')" width="100px">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.options.hidden" :disabled="scope.row.options.mode ==='client'" ></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column :label="$t('lang.ConfigSetting.WMMMode')" width="100px">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.options.wmm"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column :label="$t('lang.ConfigSetting.Encryption')" >
            <template slot-scope="scope">
              <el-select v-model="scope.row.options.encryption" :placeholder="$t('lang.ConfigSetting.pleaseChoose')" size="mini">
                <el-option
                  v-for="item in EncryptionList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column :label="$t('lang.ConfigSetting.Key')" min-width="150px">
            <template slot-scope="scope">
              <!-- 加密方式不等于No Encryption -->
              <el-row>
                <el-col :span="11">
                  <el-row  v-if="scope.row.options.encryption!=='none' && scope.row.options.encryption!==''">
                    <el-col style="margin-right: 10px" :span="20">
                      <el-input 
                        size="mini" 
                        :type="scope.row.options.viewPWD === false ? 'password' : ''"
                        v-model="scope.row.options.key" 
                        @change="(e) =>{keyChange(e, scope.row)}">
                      </el-input>
                    </el-col>
                    <el-col :span="2">
                      <i style="cursor: pointer;" @click="setPWDView(scope.row)" class="el-icon-view"></i> 
                    </el-col> 
                  </el-row>
                </el-col>
                <el-col :span="13" style="padding-left: 10px" >
                  <span
                    class="color" 
                    v-show="scope.row.options.KeyColor && scope.row.options.encryption!=='none' && scope.row.options.encryption!==''">
                    {{$t('lang.ConfigSetting.wifimessage')}}
                  </span>
                </el-col>
              </el-row>
            </template>
          </el-table-column>
        </el-table>
      
        <el-button
          type="danger"
          size="mini"
          class="Config-Buttom"
          @click="updateConfig"
          v-if="wifiData.length > 0">
          {{$t('lang.ConfigSetting.SaveApply')}}
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { updateConfig, getNetworkInfo, listConfig } from "@/api/configurationlist";
import { progressControl } from '@/api/particulars'
import { cloneDeep, isEqual } from 'lodash'
import { Form } from 'element-ui';
import networkInfo from '../networkInfo/index'
import { addConfig } from '../../../../../api/task';
import { channelOptions, htmodeOptions } from './wifiConfig'
export default {
  props:["deviceDid", "deviceSn"],
  components: {
    networkInfo
  },
  data(){
    return {
      channelOptions, // 信道选项
      htmodeOptions, // 频宽选项
      //模式
      ModeList:[{
        label:'sta',
        value:'sta'
      },
      {
        label:"ap",
        value:"ap"
      }
      ],
      deviceSettingForm: {
        channel: 'auto',
        htmode: 'HT20',
        index: '',
        sname: ''
      },
      deviceDataCopy: {},
      //加密方式
      EncryptionList:[
        {
          label:'No Encryption',
          value:'none'
        },
        {
          label:'WPA-PSK',
          value:'psk'
        },
        {
          label:'WPA2-PSK',
          value:'psk2'
        },
        {
          label:'WPA-PSK/WPA2-PSK Mixed Mode',
          value:'psk-mixed'
        }
      ],
      //算法
      AlgorithmList:[
        {
          label: this.$t('lang.wifi.auto'),
          value:'auto'
        },
        {
          label: this.$t('lang.wifi.CCMP'),
          value:'ccmp'
        },
        {
          label: this.$t('lang.wifi.TKIP'),
          value:'tkip'
        },
        {
          label: this.$t('lang.wifi.CCMP_TKIP'),
          value:'tkip+ccmp'
        }
      ],
      //loading层
      loading:true,
      UpData:true,
      //密钥验证
      KeyColor:false,
      // 网络接口基本信息
      networkInfo: [],
      timer: null,
      protoOptions: {
        static: this.$t('lang.wifi.static'),
        l2tp: 'L2TP',
        pptp: 'PPTP',
        dhcp: 'DHCP'
      },
      // wifi是否存在客户端模式
      STA: false,
      copyData: [],
      wifiData: [],
    }
  },
  watch:{
    STA: {
      immediate: true,
      handler: function() {
        clearInterval(this.timer)
        if(this.STA) {
          this.fetchNetworkInfo()
          this.timer = setInterval(() => {
            this.fetchNetworkInfo()
          }, 10000)
        }
      }
    }
  },
  activated() {
    this.fetchNetworkInfo()
    this.timer = setInterval(() => {
      this.fetchNetworkInfo()
    }, 10000)
  },
  deactivated() {
    clearInterval(this.timer)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  mounted() {
    this.getConfig()
  },
  methods:{
    // 获取wifi
    getConfig(){
      this.loading = true
      listConfig(this.deviceSn, this.deviceDid, [
        {
          section: "wifi-iface",
          config: "wireless",
          options: [
            { option: "mode" },
            { option: "ssid" },
            { option: "hidden" },
            { option: "wmm" },
            { option: "encryption" },
            { option: "key" },
            { option: "disabled" },
          ]
        },
        {
          section: "wifi-device",
          config: "wireless",
          options: [
            { option: "channel" },
            { option: "htmode" },
          ]
        },
      ]).then(res => {
        if(res.data.code === 0) {
          let data = res.data.data
          if(data.mess) {
            data.mess.forEach(ele => {
              if(ele.section === 'wifi-iface') {  
                this.wifiData = ele.s_objects
                if(this.wifiData.length > 0) {
                    this.wifiData.map((item) => {
                      if(item.options.mode === 'sta') {
                        item.options.wmm = false
                      }else{
                        // if(item.options.wmm === '0') {
                        //   item.options.wmm = false
                        // }else{
                        //   item.options.wmm = true
                        // }
                        item.options.wmm = item.options.wmm !== '0';
                      }
                      
                      item.options.hidden = item.options.hidden === '1';
                      item.options.disabled = item.options.disabled !== '1';         
                      if(item.options.key.length < 8) {
                        this.$set(item.options, 'KeyColor', true)
                      }else{
                        this.$set(item.options, 'KeyColor', false)
                      }
                      if(item.options.mode == 'sta') {
                        this.STA = true
                      }
                      this.$set(item.options, 'viewPWD', false)
                    })
                }
              }else if(ele.section === 'wifi-device') {
                this.deviceSettingForm.channel = ele.s_objects[0].options.channel
                this.deviceSettingForm.htmode = ele.s_objects[0].options.htmode
                this.deviceSettingForm.index = ele.s_objects[0].index
                this.deviceSettingForm.sname = ele.s_objects[0].sname
              }
              
            })
          }
        }        
         this.copyData = cloneDeep(this.wifiData)
         this.deviceDataCopy = cloneDeep(this.deviceSettingForm)
         this.loading = false
        }).catch(err => {
          this.$message({
            message: this.$t('lang.request.timeout'),
            type: "warning"
          })
        })
    },
    keyChange(val, row) {
      if(val.length < 8) {
        this.$set(row.options, 'KeyColor', true)
      }else{
        this.$set(row.options, 'KeyColor', false)
      }
    },
    setPWDView(row) {
      this.$set(row.options, 'viewPWD', !row.options.viewPWD)
    },
    //禁用与开启切换
    OnOff(row){
      row.options.disabled = row.options.disabled == '' ? '1' : ''
    },
    //保存配置
    updateConfig(){
      if(!isEqual(this.copyData, this.wifiData) || !isEqual(this.deviceSettingForm, this.deviceDataCopy)) {
        let isSave = true
        let dataCopy = cloneDeep(this.wifiData)
        // 判断秘钥是否符合条件，不符合则返回，符合直接提交
        dataCopy.map((item, index) => {
          if(item.options.encryption!=='none' && item.options.encryption!=='') {          
            if(item.options.KeyColor == true || item.options.key === '') { // 为空代表秘钥输入框没有发生变化但是为空（初始值）
              isSave = false
            }
          }else{
            item.options.key = ''
          }
          item.options.hidden = item.options.hidden  ? '1' : '';
          item.options.wmm = item.options.wmm  ? '1' : '0';
          item.options.disabled = item.options.disabled  ? '0' : '1';
          this.$set(item, 'section', 'wifi-iface')
          this.$set(item, 'config', 'wireless')
          this.$set(item, 'action', 0)
          this.$set(item, 'index', [item.index||index])
          if(item.index[0]===undefined) item.index[0] = 0
          delete item.options.KeyColor
          delete item.options.viewPWD
          delete item.sname
        })
        if(isSave) {
          let device = {
            // sname: this.deviceSettingForm.sname,
            index: [this.deviceSettingForm.index?this.deviceSettingForm:0],
            section: "wifi-device",
            config: "wireless",
            action: 0,
            options: {
              channel: this.deviceSettingForm.channel,
              htmode: this.deviceSettingForm.htmode
            }
          }
          dataCopy.push(device)
          this.loading = true
          updateConfig(this.deviceSn, this.deviceDid, dataCopy).then(res => {
            if(res.data.data.result === 1){
              this.$message({
                  showClose: true,
                  message: this.$t('lang.ConfigSetting.Successfulconfiguration'),
                  type: "success"
                })
                //重启wifi进程
              progressControl([{process: "wifi", action: "restart", type: 1}],this.deviceDid.toString(),this.deviceSn)
              .then((res)=>{
                //获取新的配置数据
                this.getConfig()
                this.fetchNetworkInfo()
                this.loading = false
              })
            } 
            else {
              this.$message({
                showClose: true,
                message: this.$t('lang.ConfigSetting.Configurationerror'),
                type: 'warning'
              });
              return
            }
          })
        }else{
          return
        }
      }else{
        this.$message({
          showClose: true,
          message: this.$t('lang.ConfigSetting.Nochangesmade'),
          type: 'warning'
        });
        return
      }
    },
    // 获取lan接口基本信息
    fetchNetworkInfo() {
        getNetworkInfo(this.deviceDid, this.deviceSn, ['wwan']).then(res => {
          this.networkInfo = res.data.data.mess['wwan']
        }).catch(() => {})
        
    },
    //计算毫秒数
    getDuration(msd) {
       var time = msd;
      if (null != time && "" != time) {
        if (time > 60 && time < 60 * 60) {
          time =
            parseInt(time / 60.0) +
            this.$t("lang.particulars.minutes") +
            parseInt((parseFloat(time / 60.0) - parseInt(time / 60.0)) * 60) +
            this.$t("lang.particulars.seconds");
        } else if (time >= 60 * 60 && time < 60 * 60 * 24) {
          time =
            parseInt(time / 3600.0) +
            this.$t("lang.particulars.hours") +
            parseInt(
              (parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60
            ) +
            this.$t("lang.particulars.minutes") +
            parseInt(
              (parseFloat(
                (parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60
              ) -
                parseInt(
                  (parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60
                )) *
                60
            ) +
            this.$t("lang.particulars.seconds");
        } else if (time >= 60 * 60 * 24) {
          time =
            parseInt(time / 3600.0 / 24) +
            this.$t("lang.particulars.Day") +
            parseInt(
              (parseFloat(time / 3600.0 / 24) - parseInt(time / 3600.0 / 24)) *
                24
            ) +
            this.$t("lang.particulars.hours") +
            parseInt(
              (parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60
            ) +
            this.$t("lang.particulars.minutes") +
            parseInt(
              (parseFloat(
                (parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60
              ) -
                parseInt(
                  (parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60
                )) *
                60
            ) +
            this.$t("lang.particulars.seconds");
        } else {
          time = parseInt(time) + this.$t("lang.particulars.seconds");
        }
      }
      return time;
    },
    // 计算流量
    getTraffic(byte) {
      let kb = 0
      let mb = 0
      let g = 0
      let result = ''
      if(byte > 1024) {
        kb = byte / 1024
      }
      if(kb > 1024) {
        mb = kb / 1024 
      }
      if(mb > 1024) {
        g = mb / 1024
      }
      if(g !== 0) {
        result = Math.floor(g * 10) / 10 + 'G'
      }else if(mb !== 0) {
        result = Math.floor(mb * 10) / 10 + 'M'
      }else if(kb !== 0) {
        result = Math.floor(kb * 10) / 10 + 'K'
      }else if(byte !== 0){
        result = byte + 'B'
      }else{
        result = '0'
      }
      console.log(result);
      return result
    }
  }
};
</script>

<style scoped>
.color {
  color: #f56c6c;
}
.device-setting {
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
}
</style>
<style src='../common.css' scoped></style>

